module.exports = __webpack_public_path__ + "img/aaa614d0be07765b7912f09f90d706f9.png";